import configs from '../../../configs';
import MainService from '../main.service';

export default class UserService {
  mainService = null;
  path = null;

  constructor() {
    this.mainService = new MainService();
    this.path = configs.user_api_url;
  }

  SaveCustomColumns = body => {
    return this.mainService.post(this.path + '/column-options', body);
  };

  listCustomColumns = type => {
    return this.mainService.get(this.path + '/column-options/' + type);
  };

  listUsers = uuid_user => {
    return this.mainService.get(this.path + '/usrs/' + uuid_user);
  };

  listUsersByServer = data => {
    const { page, size, fields } = data;
    return this.mainService.get(
      this.path +
        '/usrs?page=' +
        page +
        '&size=' +
        size +
        '&str_abi_id=' +
        fields.str_abi_id +
        '&str_name=' +
        fields.str_name +
        '&str_email=' +
        fields.str_email +
        '&str_profile_name=' +
        fields.str_profile_name +
        '&str_zone_name=' +
        fields.str_zone_name +
        '&str_country_name=' +
        fields.str_country_name +
        '&str_site_name=' +
        fields.str_site_name +
        '&str_language=' +
        fields.str_language +
        '&dat_accept_terms_of_use=' +
        fields.dat_accept_terms_of_use +
        '&str_job_position_name=' +
        fields.str_job_position_name +
        '&str_user_type=' +
        fields.str_user_type +
        '&str_user_principal_name=' +
        fields.str_user_principal_name +
        '&str_employee_status=' +
        fields.str_employee_status,
    );
  };

  findUser = data => {
    return this.mainService.get(
      this.path +
        `/tasters?str_name=${data.str_name}&uuid_zone=${data.uuid_zone}&uuid_country=${data.uuid_country}&uuid_site=${data.uuid_site}`,
    );
  };

  updateUser = obj_user => {
    return this.mainService.put(this.path + '/usrs', obj_user);
  };

  updateNonAbiUser = obj_user => {
    return this.mainService.put(this.path + '/non-abi-usrs', obj_user);
  };

  deleteUser = uuid_user => {
    return this.mainService.patch(this.path + '/usrs/' + uuid_user);
  };

  setImage = data => {
    return this.mainService.post(
      `${this.path}/usrs/${data.uuid_user}/images`,
      data,
    );
  };

  setLanguage = data => {
    return this.mainService.put(
      `${this.path}/usrs/${data.uuid_user}/languages`,
      data,
    );
  };

  getJobPosition = () => {
    return this.mainService.get(`${this.path}/job-positions`);
  };

  updateUserRowPage = body => {
    return this.mainService.post(`${this.path}/row-pages`, body);
  };

  getUserRowPage = () => {
    return this.mainService.get(`${this.path}/row-pages`);
  };

  getUserContinuousTyping = () => {
    return this.mainService.get(`${this.path}/continuous-types`);
  };

  getUserCompetitionRound = uuid_round => {
    return this.mainService.get(
      `${this.path}/competition-rounds/${uuid_round}/usrs`,
    );
  };

  updateUserContinuousTyping = bol_continuous_type => {
    return this.mainService.put(
      this.path + '/continuous-types',
      bol_continuous_type,
    );
  };

  listAbsenceReason = () => {
    return this.mainService.get(`${this.path}/absence-reasons`);
  };

  getAbsenceReason = data => {
    const { page, size, fields } = data;
    return this.mainService.get(
      `${this.path}/absences?dat_start=${fields.dat_start}&dat_finish=${fields.dat_finish}&str_name_reason=${fields.str_name_reason}&page=${page}&size=${size}`,
    );
  };

  delAbsenceReason = uuid_user_absence => {
    return this.mainService.patch(`${this.path}/absences/${uuid_user_absence}`);
  };

  saveAbsenceReason = data => {
    return this.mainService.post(`${this.path}/absences`, data);
  };
  getTasterType = data => {
    return this.mainService.post(`${this.path}/taster-types`, data);
  };
  getEvaluationReportUser = data => {
    return this.mainService.post(`${this.path}/tasters`, data);
  };
  downloadLists = (params = {}) => {
    const query = new URLSearchParams();
    if (params.str_report_type)
      query.set('str_report_type', params.str_report_type);
    if (params.page) query.set('page', params.page);
    if (params.size) query.set('size', params.size);
    if (params.str_order) query.set('str_order', params.str_order);
    if (params.str_file_name) query.set('str_file_name', params.str_file_name);
    const queryStr = query.toString();
    return this.mainService.get(
      `${this.path}/logs${queryStr ? `?${queryStr}` : ''}`,
    );
  };
  //nps
  createNpsLog = data => {
    return this.mainService.post(`${this.path}/nps-logs`, data);
  };
  updateNpsLog = data => {
    return this.mainService.put(`${this.path}/nps-logs`, data);
  };
  npsPopups = data => {
    return this.mainService.post(`${this.path}/nps-popups`, data);
  };
  submitNpsPopup = data => {
    return this.mainService.put(`${this.path}/nps-popups`, data);
  };
  submitNpsDurations = data => {
    return this.mainService.post(`${this.path}/nps-durations`, data);
  };
  // Get Email Groups
  getEmailGroups = uuid_email_group => {
    return this.mainService.get(
      `${this.path}/email-groups/${uuid_email_group}`,
    );
  };
  //Upgrade Center
  getUpgradeCenter = data => {
    const { page, size, fields } = data;
    const {
      dat_start = '',
      dat_end = '',
      str_sprint_number = '',
      str_sprint_content = '',
    } = fields;
    return this.mainService.get(
      `${this.path}/sprint-materials?page=${page}&size=${size}&dat_start=${dat_start}&dat_end=${dat_end}&str_sprint_number=${str_sprint_number}&str_sprint_content=${str_sprint_content}`,
      data,
    );
  };
  AddSprintMaterials = data => {
    return this.mainService.post(`${this.path}/sprint-materials`, data);
  };
  updateSprintMaterials = data => {
    return this.mainService.put(`${this.path}/sprint-materials`, data);
  };
  getSprintNumber = () => {
    return this.mainService.get(`${this.path}/sprint-numbers`);
  };
  deleteSprintMaterials = uuid_sprint_number => {
    return this.mainService.patch(
      `${this.path}/sprint-materials/${uuid_sprint_number}`,
    );
  };
  readSprintMaterials = data => {
    return this.mainService.post(`${this.path}/read-status`, data);
  };
  getSprintReadStatus = () => {
    return this.mainService.get(`${this.path}/read-status`);
  };

  listRoles = scene =>
    this.mainService.get(
      `${this.path}/roles${
        scene ? `?str_scene=${encodeURIComponent(scene)}` : ''
      }`,
    );

  getRolePermissions = uuidRoleId =>
    this.mainService.get(`${this.path}/roles/${uuidRoleId}/permissions`);

  createRole = body => this.mainService.post(`${this.path}/roles`, body);

  updateRole = (uuidRoleId, body) =>
    this.mainService.put(`${this.path}/roles/${uuidRoleId}`, body);

  getRoleDeletionPreview = uuidRoleId =>
    this.mainService.get(
      `${this.path}/roles/${uuidRoleId}/deletion-preview`,
    );

  deleteRole = (uuidRoleId, affectedUserCount) =>
    this.mainService.fetchFun(
      `${this.path}/roles/${uuidRoleId}`,
      'PATCH',
      JSON.stringify({ int_affected_user_count: affectedUserCount }),
    );
}
